<template>
  <footer-default v-if="!mostrarFooterPersonalizado"></footer-default>

  <v-layout
    v-else
  >
    <v-footer
      app
      absolute
      class="pa-1 px-0"
    >
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-html="autoatendimento.footerHtml"></div>
    </v-footer>
  </v-layout>
</template>

<script>
import { ref, watchEffect } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import FooterDefault from './FooterDefault.vue'
import useCentralStore from '@/store/central'
import useAuthStore from '@/store/auth'

export default ({
  components: {
    FooterDefault,
  },

  setup() {
    const autoatendimento = ref({})
    const mostrarFooterPersonalizado = ref(false)

    const { footerHtml } = storeToRefs(useCentralStore())
    const { isLoggedIn } = storeToRefs(useAuthStore())

    function verificarHTML(script) {
      if (!script) return false

      const scriptTrimmed = script.trim()
      if (scriptTrimmed.startsWith('<')) {
        if (scriptTrimmed.includes('>')) {
          return true
        }
      }

      return false
    }

    watchEffect(async () => {
      if (isLoggedIn.value) {
        mostrarFooterPersonalizado.value = verificarHTML(footerHtml.value)
      }
    })

    return {
      autoatendimento,
      mostrarFooterPersonalizado,
    }
  },
})
</script>
